/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { map } from 'lodash';
import { BlendBridge } from 'blb-types/blendBridge';
import { generateTaskDescriptionKey, TaskDescription } from './';

const styles = StyleSheet.create({
  column: {
    display: 'flex',
    flexBasis: '100%',
    flexDirection: 'column',
  },
  descriptionRow: {
    marginBottom: 10,
  },
});

interface ColumnsProps {
  columns: BlendBridge.API.TaskDescription[][];
  form?: any;
}

export const Columns: React.FC<ColumnsProps> = ({ columns, form }: ColumnsProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {map(columns, (col, idx) => (
        // columns are static and are never re-ordered or filtered,
        // so we will use the column's index as the key
        <div className={css(styles.column)} key={idx}>
          {map(col, row => {
            const key = generateTaskDescriptionKey(row);
            return (
              <TaskDescription className={css(styles.descriptionRow)} form={form} key={key} taskDescription={row} />
            );
          })}
        </div>
      ))}
    </div>
  );
};
